export const VALIDATION_ERROR = 'VALIDATION_ERROR';
export const UNAUTHORIZED_RESPONSE_ERROR = 'UNAUTHORIZED_RESPONSE_ERROR';
export const FORBIDDEN_ERROR= 'FORBIDDEN_ERROR';
export const SERVER_ERROR = 'SERVER_ERROR';
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
export const LOCKED_ERROR = 'LOCKED_ERROR';
export const PAGE_NOT_FOUND_ERROR = 'PAGE_NOT_FOUND_ERROR';


// WEBPACK FOOTER //
// ./src/utils/error-types.js